import UpdateFilterUrl from "./updatefilterurl.js";
import FilterValues from "./filtervalues.js";
import FilterMenu from "./filtermenu.js";
import SelectedFilters from "./selectedfilters.js";
import { prodListValues } from './shared.js';

const searchText = document.getElementById('txtInnerSearch');
const submit = document.getElementById('submitInnerSearch');

class SubSearchFilter {
    events() {
        if (submit && searchText) {
            submit.addEventListener('click', (e) => {
                e.preventDefault();
                var subSearch = searchText.value;

                if (subSearch.length === 0) {
                    this.clear();
                    UpdateFilterUrl.update(FilterValues, prodListValues, false);
                } else {
                    if (this.checkForTagName(subSearch)) {
                        this.add(true);
                        UpdateFilterUrl.update(FilterValues, prodListValues, false);
                    } else {
                        searchText.value = '';
                    }
                }
            });
            
            searchText.addEventListener('keydown', (e) => {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    submit.click();
                }
            });
        }
    };

    checkForTagName(term) {
        FilterMenu.addTagFilters();

        return Array.prototype.every.call(FilterMenu.getMenuContainer.querySelectorAll('input[data-filter], button[data-filter]'), (element) => {
            if (element.getAttribute('data-filter').toLowerCase() === term.toLowerCase()) {
                element.click();
                return false;
            }
            return true;
        });
    };

    add(logFilter) {
        var filterName = document.getElementById('SubSearchFilterTitle').value.replace('##search##', searchText.value);

        SelectedFilters.removeFromSelectedFilter(searchText);
        FilterValues.addSubSearchFilter(searchText.id, searchText.value, logFilter);
        searchText.value = '';
        SelectedFilters.addToSelectedFilter(searchText, filterName);
    };

    update(term) {
        searchText.value = term;
        this.add(true);
    };

    clear() {
        searchText.value = '';
        FilterValues.removeSubSearchFilter();
        SelectedFilters.removeFromSelectedFilter(searchText);
    };
}

export default new SubSearchFilter();